<template>
  <!-- 数据字典 -->
  <div>
    <div class="box">
      <!-- 左边 -->
      <div class="boxleft glo_Table">
        <el-table
          :data="menuTableData"
          style="width: 100%"
          row-key="departmentId"
          border
          :height="leftHeight"
          default-expand-all
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          @row-click="rowClickLeft"
        >
          <el-table-column
            prop="typeShow"
            label="字典类型名称"
            sortable
            min-width="170"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <!-- 按钮列表 -->
        <div class="glo_btnList" ref="btnList">
          <div class="glo_btnList_left">
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems glo_bgcMainColor"
              @click="menuadd()"
              >新增字典
            </el-button>
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems"
              @click="delBtns('more')"
              >批量删除
            </el-button>
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems"
              @click="qiYong('more')"
              >批量启用
            </el-button>
            <el-button
              v-if="hasPermiss('aaaaa')"
              class="glo_btnItems"
              @click="jinYong('more')"
              >批量禁用
            </el-button>
          </div>

          <queryBtns
            :MoreConditions="MoreConditions"
            :showMoreBtns="false"
            @clerBtns="clerBtns"
            @queryBtn_ok="queryBtn_ok"
            @moreParam="moreParam"
          ></queryBtns>
        </div>
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            :model="queryData"
            :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
            label-position="left"
          >
            <el-form-item class="queryItems" label="字典类型:">
              <el-select
                v-model="queryData.type"
                filterable
                clearable
                default-first-option
                placeholder="请选择"
                @change="queryBtn_ok"
              >
                <el-option
                  v-for="(item2, index2c) in menuTableData"
                  :key="index2c"
                  :label="item2.typeShow"
                  :value="item2.type"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="queryItems" label="显示值名称:">
              <el-input
                clearable
                v-model="queryData.val"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <div class="glo_Table" ref="tableWrapper">
          <el-table
            :height="tableHeigth"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            stripe
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column fixed="left" label="序号" type="index" width="60">
            </el-table-column>
            <el-table-column fixed="left" type="selection" width="60">
            </el-table-column>
            <template v-for="(item, index) in myTableHeard">
              <el-table-column
                v-if="item.field == 'isShowShow'"
                :key="index"
                :label="item.name"
                sortable
                :min-width="item.width"
              >
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.isShowShow == '禁用'"
                    style="color: #f00"
                  >
                    {{ scope.row.isShowShow }}
                  </div>
                  <div v-else>{{ scope.row.isShowShow }}</div>
                </template>
              </el-table-column>
              <el-table-column
                v-else-if="item && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                sortable
                :min-width="item.width"
                :data-isTotal="item.isTotal"
              >
              </el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" min-width="220px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="menumodify(scope.row, 'right')"
                    >编辑</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="qiYong('one', scope.row.confDictId)"
                    >启用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="jinYong('one', scope.row.confDictId)"
                    >禁用</el-button
                  >
                  <el-button
                    class="rbtns"
                    @click.stop="delBtns('one', scope.row.confDictId)"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页组件 -->
        <paging
          ref="pags"
          :pageNum="pageStart"
          :total="total"
          :sizeList="sizeList"
          :size="pageTotal"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="PopUpTitle"
      :isShowDialog="menushowBOX"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormDataRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          v-if="menushowBOX"
          ref="dialogFormDataRef"
          :model="dialogFormData"
          label-width="100px"
          :rules="rules"
        >
          <el-form-item class="dialogFormItems" prop="bbb" label="字典类型:">
            <el-select
              v-model="dialogFormData.type"
              clearable
              filterable
              placeholder="请选择"
              :disabled="dialogType == 'edit'"
            >
              <el-option
                v-for="(item, index) in menuTableData"
                :key="index"
                :label="item.typeShow"
                :value="item.type"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="val" label="显示值:">
            <el-input
              placeholder="请输入"
              clearable
              v-model="dialogFormData.val"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="isShow" label="状态:">
            <el-select
              clearable
              filterable
              v-model="dialogFormData.isShow"
              placeholder="请选择"
            >
              <el-option
                v-for="item in isShowList"
                :key="item.val"
                :label="item.name"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="dialogFormItems" prop="sort" label="排序:">
            <el-input
              placeholder="请输入"
              v-model="dialogFormData.sort"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            class="dislogFormTextarea"
            prop="descript"
            label="备注:"
          >
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogFormData.descript"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>


<script>
import paging from "@/components/pagings.vue";
import queryBtns from "@/components/queryBtns.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    myDialog,
  },
  data() {
    return {
      bumenTypeList: [], //部门类型
      dialogFormData: {
        descript: "", //描述
        isShow: "1", //是否启用 0=否 1=是
        type: "", //字典类型
        typeShow: "", //字典类型展示值
        sort: "1", //
        val: "", //字典值
      },
      rules: {
        departmentName: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        parentId: [{ required: true, message: "请输入", trigger: "blur" }],
        aaa: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      PopUpTitle: "", //弹窗标题
      menushowBOX: false, //菜单弹窗
      dialogType: "add",
      menuTableData: [],
      diaWidth: "40%",
      //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

      queryData: {
        val: "",
        type: "",
      },

      // ================
      pageStart: 1, //页码
      total: 0, //总条数
      sizeList: [10, 20, 50, 100, 200],
      pageTotal: this.$COMMON.pageTotals, //一页几条
      nextPage: false, //是否有下一页
      show_sortTableHeard: false, //显示弹窗
      show_upload: false, //显示上传弹窗
      myTableHeard: [], //我的表头
      originalTabelHeadeTitle: [],
      selectLength: 0, //显示的长度
      allCheck: false, //全选
      leftHeight: "75vh",
      tableHeigth: "75vh",
      tabelHeadeTitle: [
        {
          name: "字典类型",
          field: "typeShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "显示值",
          field: "val",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "状态",
          field: "isShowShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "100",
        },
        {
          name: "是否出厂配置",
          field: "isInitializationShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "130",
        },
        {
          name: "备注",
          field: "descript",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "排序",
          field: "sort",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "80",
        },
        {
          name: "新建时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "160",
        },
        {
          name: "申请人",
          field: "createUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          width: "120",
        },
      ],
      tableData: [],
      totalArr: [], //需要合计的字段
      className: "", //导出需要
      fieldName: [], //下载字段名
      head: [], //下载表头字段
      fileList: [],
      sortName: "组织架构", //排序名
      pageGroupName: "organizationalStructure", //页面标识
      selectTableData: [], //选中的数据

      deperIds: [],
      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件
      isShowList: [
        {
          val: "1",
          name: "启用",
        },
        {
          val: "0",
          name: "禁用",
        },
      ],
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    this.departmentHierarchy(); //左边列表
  },
  mounted() {
    const that = this;
    this.getData();
    // this.getStatusValList("finance_in_record_v1.approve_status") || []; //审核状态列表
    // this.getdepartmentTypeList();
  },
  activated() {
    this.$nextTick(() => {
      this.fetTableHeight();
    });
  },
  watch: {},
  methods: {
    rowClickLeft(e) {
      console.log(e);
      this.queryData.type = e.type;
      this.getData();
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    clerBtns() {
      //  重置按钮
      this.queryData = {
        val: "",
        type: "",
      };
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 递归获取部门下所有id
    getDpIds(data) {
      let ids = this.deperIds || [];
      ids.push(data.departmentId);
      let arrs = data.children || [];
      for (var i = 0; i < arrs.length; i++) {
        ids.push(arrs[i].departmentId);
        let arr2 = arrs[i].children || [];
        for (var j = 0; j < arr2.length; j++) {
          this.getDpIds(arr2[j]);
        }
      }
      this.deperIds = ids;
      return this.deperIds;
    },
    // 部门类型下拉列表
    getdepartmentTypeList() {
      this.$API.getdepartmentTypeList().then((res) => {
        if (res.data.status == "success") {
          let arrs = res.data.result || [];
          this.bumenTypeList = arrs;
        }
      });
    },
    // 部门层级列表
    departmentHierarchy() {
      this.$API.wtl_getConfDictTypeList().then((res) => {
        if (res.data.status == "success") {
          let bmList = res.data.result || [];
          this.menuTableData = bmList;
        }
      });
    },

    //菜单新建
    menuadd() {
      this.dialogFormData.type = this.queryData.type;
      // this.dialogFormData.typeShow = row.typeShow;
      this.PopUpTitle = "新建字典";
      this.menushowBOX = true;
      this.dialogType = "add";

      console.log(this.dialogFormData);
    },
    //菜单修改
    menumodify(row, types) {
      console.log(row);

      this.dialogFormData.type = row.type || "";
      this.dialogFormData.typeShow = row.typeShow || "";
      this.dialogFormData.sort = row.sort || "1";
      this.dialogFormData.descript = row.descript || "";
      this.dialogFormData.isShow = row.isShow + "" || "1";
      this.dialogFormData.val = row.val || "";
      this.dialogFormData.confDictId = row.confDictId || "";

      this.PopUpTitle = "字典编辑";
      this.menushowBOX = true;
      this.dialogType = "edit";

      // if (types == "left") {
      // } else {
      // }
    },
    // 删除
    delBtns(types, id) {
      let ids = [];
      if (types == "more") {
        //批量删除
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要删除的字典数据");
          return false;
        } else {
          this.selectTableData.forEach((item) => {
            ids.push(item.confDictId);
          });
        }
      } else {
        // 单个删除
        ids = [id];
      }
      this.$confirm("是否删除所选字典?", "提示:")
        .then(() => {
          let param = {
            confDictIds: ids,
          };
          this.$API.wtl_delConfDict(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    //启用
    qiYong(types, id) {
      let ids = [];
      if (types == "more") {
        //批量
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要启用的字典数据");
          return false;
        } else {
          this.selectTableData.forEach((item) => {
            ids.push(item.confDictId);
          });
        }
      } else {
        // 单个删除
        ids = [id];
      }
      this.$confirm("是否启用所选字典?", "提示:")
        .then(() => {
          let param = {
            confDictIds: ids,
          };
          this.$API.wtl_startConfDict(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            }
          });
        })
        .catch(() => {});
    },

    //禁用
    jinYong(types, id) {
      let ids = [];
      if (types == "more") {
        //批量
        if (this.selectTableData.length < 1) {
          this.$message.warning("请选择需要禁用的字典数据");
          return false;
        } else {
          this.selectTableData.forEach((item) => {
            ids.push(item.confDictId);
          });
        }
      } else {
        // 单个删除
        ids = [id];
      }
      this.$confirm("是否禁用所选字典?", "提示:")
        .then(() => {
          let param = {
            confDictIds: ids,
          };
          this.$API.wtl_stopConfDict(param).then((res) => {
            if (res.data.status == "success") {
              this.$message.success(res.data.message || "操作成功");
              this.getData();
            }
          });
        })
        .catch(() => {});
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.menushowBOX = false;
      this.dialogFormData = {
        descript: "", //描述
        isShow: "1", //是否启用 0=否 1=是
        type: "", //字典类型
        typeShow: "", //字典类型展示值
        sort: "1", //
        val: "", //字典值
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.menuTableData.forEach((item) => {
            if (item.type == this.dialogFormData.type) {
              this.dialogFormData.typeShow = item.typeShow;
            }
          });
          if (this.dialogType == "add") {
            // 新建
            this.$API.wtl_addConfDict(this.dialogFormData).then((res) => {
              this.$message.success(res.data.message || "新建成功");
              this.menushowBOX = false;
              this.$TOOLS.resetForm(this, formName);
              this.getData();
            });
          } else {
            // 修改
            this.$API.wtl_udpateConfDict(this.dialogFormData).then((res) => {
              this.$message.success(res.data.message || "修改成功");
              this.menushowBOX = false;
              this.$TOOLS.resetForm(this, formName);
              this.getData();
            });
          }
        }
      });
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.menushowBOX = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },

    /**
     * =========================按钮部分的方法=>开始??????????????????????????????????
     */

    //导出操作
    handleCommand_dc(command) {
      if (command == "dc") {
        // 导出
        this.exportBtn();
      } else if (command == "dcmb") {
        // 下载模板
        this.exportTemplateDownload();
      } else if (command == "scmb") {
        // 上传模板
        this.upLoadBtn();
      }
    },

    // ===============================================导出部分=结束======

    /**
     * ******************************计算表格高度**开始*************************
     */
    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth = tabHeight;

        this.leftHeight = windonHeight - 85;
        this.$refs.mytable.doLayout();
      });
    },
    /**
     * ******************************计算表格高度**结束*************************
     */

    // 获取数据
    getData() {
      let param = {
        val: this.queryData.val,
        type: this.queryData.type,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
      };
      this.$API.wtl_getConfDictList(param).then((res) => {
        // this.className = res.data.result.className || "";
        this.tableData = res.data.result.data || [];
        this.total = res.data.result.pageCount || 0;
        this.fetTableHeight();
      });
    },
    // 查询按钮
    queryBtn_ok() {
      this.pageStart = 1;
      this.getData();
    },

    // 合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property == that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    //分页
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
  },
};
</script>

<style scoped lang='less'>
.box {
  // width: 100%;
  display: flex;
  .boxleft {
    width: 200px;
    margin-right: 30px;
  }
  .boxright {
    flex: 1;
    overflow: auto;
  }
}

.tablebut {
  margin-left: 15px;
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }
  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerbox {
  width: 100%;
  display: flex;
  justify-content: center;
}

.footerbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 50px;
}

.newForm {
  margin-left: 80px;
  .queryItem1 {
    width: 60%;
    margin-top: 20px;
    display: flex;
    .inputstyle {
      width: 100%;
      display: flex;
    }
  }
}

.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input,
.HeadInputbox .item_right .singleinp1 .el-date-editor.el-input__inner {
  width: 100%;
}

.frominput ::v-deep {
  .el-input__inner {
    height: 30px;
  }
}
</style>